import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthGuard} from "@core/guards/auth.guard";
import {AuthService} from "@core/services/auth.service";
import {ApiService} from "@core/services/api.service";
import {AccountService} from "@core/services/account.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {JwtInterceptor} from "@core/interceptors/jwt.interceptor";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import { DeviceService } from './services/device.service';
import { TaskContextService } from './services/task-context.service';
import { RestrictionService } from './services/restriction.service';
import { GroupService } from './services/group.service';
import { PersistencyService } from './services/persistency.service';

@NgModule({
  imports: [CommonModule],
  providers: [AuthGuard,
      AuthService,
      ApiService,
      AccountService,
      GroupService,
      RestrictionService,
      TaskContextService,
      DeviceService,
      PersistencyService,
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
      provideAnimationsAsync()
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}